

/* eslint-disable */
import Vue from 'vue'
import App from './App'
import router from './router'
import FastClick from 'fastclick'
import store from './store'
import apiUrl from './api/api'
import Head from './components/appHead'
import confirm from './components/confirm'
import 'reset-css'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import 'lib-flexible'
import webBridge from './lib/webBridge'
import './permission' 
import pushMsg from './components/pushMsg/main.js'
import loading from './components/loading/main.js'
import Toast from 'mand-mobile/components/toast'
import filters from './lib/filters'
import '@/m-common/directive';

import VueLazyload from 'vue-lazyload'
import Vant from 'vant';
import echarts from 'echarts'
import _ from 'lodash'
import '@/m-common/components/SvgIcon/main.js';
import '@/m-common/style/index.scss'
import '@/assets/vant.scss'

if ('addEventListener' in document && 'ontouchstart' in window) {
FastClick.prototype.focus = function (targetElement) {
targetElement.focus()
}
document.addEventListener('DOMContentLoaded', function () {
FastClick.attach(document.body)
}, false)
}
Vue.config.productionTip = false
Vue.component('Head', Head)
Vue.component('confirm', confirm)
Vue.component('XDialog', XDialog)
Vue.use(VueLazyload)
Vue.use(LoadingPlugin)
Vue.use(pushMsg)
Vue.use(loading)  
Vue.use(ToastPlugin, { type: 'text', position: 'middle', width: 'auto' })
Vue.use(Vant)
Vue.prototype.$api = apiUrl
Vue.prototype.$toast = Toast 
Vue.prototype.$echarts = echarts
Vue.prototype._ = _
Object.keys(filters).forEach(key => {
Vue.filter(key, filters[key])
})
import './assets/resetStyle.less'
import './assets/index.scss'
import initCollectEvent from '@/m-common/lib/collectPoint'
initCollectEvent({
sysTitle: '老铁助手519聚合项目' 
})

import initArms from '@/m-common/lib/armsRum'
initArms({
pid: 'j7rkhvvh0g@246cbe03e1b687f', // 必填：每个项目在阿里云生成的唯一值
endpoint: 'https://j7rkhvvh0g-default-cn.rum.aliyuncs.com', // 必填：每个项目在阿里云生成的唯一值
appCode: 519, // 必填：改成每个项目自己地上铁内部标识
exceptProdAlsoRun: false
})

const v = new Vue({
el: '#app',
router,
store,
components: {
App
},
template: '<App/>'
})









// WEBPACK FOOTER //
// ./src/main.js